import api from '@/api';
// import router from '@/router';

export default {
    namespaced: true,
    state: {
        authenticated: [],
    },
    actions: {
        login() {
            window.location.href = api.auth.loginUrl();
            // console.log(api.auth.loginUrl());
        },
        logout() {
            window.location.href = api.auth.logoutUrl();
        },
        async verify() {
            try {
                await api.auth.verify();
                return true;
            } catch (err) {
                if (err.response.status === 401) {
                    return false;
                }
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
                return false;
            }
        },
    },
};
